module.exports = __webpack_public_path__ + "static/media/NVRE_logo.e7816484.png";